export const getPWLContractAddress = () => {
  return '0xed28e0E916c7fca4DF23399f6441514c09725692'
}